export const Projects = [
    {
        thumbnail: "./images/portfolio3.png",
        title: "Personal Website: React3Fiber",
        tags: ["React3Fiber", "CSS","TailWindCSS", "Firebase"],
        paragraph: "This is a personal website demonstrating simple projects that you can do with R3F.",
        codelink: "https://github.com/cprice2work",
        projectlink: "https://christianjprice3.web.app",
        projectlinkText: "View Project"
    },
    {
        thumbnail: "./images/wordporess.png",
        title: "Personal Website: Wordpress",
        tags: ["Wordpress", "CSS", "React"],
        paragraph: "This is a basic website that I built in wordpress. ",
        codelink: "https://github.com/cprice2work",
        projectlink: "https://christianjprice.com",
        projectlinkText: "View Project"
    },
    {
        thumbnail: "./images/perssonalsite.png",
        title: "Personal Website: React with StyledComponents",
        tags: ["React", "StyledComponents", "Firebase"],
        paragraph: "Website made with react with the use of styled components. ",
        codelink: "https://github.com/cprice2work",
        projectlink: "https://christianjprice.vercel.app",
        projectlinkText: "View Project"
    }
]